import React from "react";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import { renderPrice } from "../../Utils/functions";
import { useList } from "./Hooks";
import { IoLocationSharp } from "react-icons/io5";
import { AiOutlineClose, AiOutlineSearch } from "react-icons/ai";
import Loading from "../../Components/Loading";
const List = () => {
  const {
    data,
    loading,
    changeObj,
    init,
    search,
    getValue,
    clearFilters,
    drawer,
    setDrawer,
    navigate,
    renderFilters,
    city,
    category,
    dispatch,
    getNext,
    nextLoading
  } = useList();


  return (
    <div className="list-products">
      <header className="d-flex justify-content-between">
        <div className="d-flex  align-items-center">
          <button
            className="btn"
            onClick={() => {
              navigate(-1);
            }}
          >
            <BsArrowRight />
          </button>
          <p className="fs-12 m-0">لیست آگهی ها</p>
        </div>
      </header>

      <div className="container mt-2">
        <div className="row mb-2">
          <div className="col-12">
            <div className="search-box-list">
              <div className="d-flex align-items-center">
                <button>
                  <AiOutlineSearch size={"1.3rem"} />
                </button>
                <input
                  value={
                    getValue("search") && getValue("search") != undefined
                      ? getValue("search")
                      : ""
                  }
                  onChange={({ target: { value } }) => {
                    changeObj("search", value);
                  }}
                />
              </div>
              <div>
                <Link to="/cities">
                  <IoLocationSharp size={"1.1rem"} />
                  <span>{city?.label || "همه شهر ها"}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>{" "}
        <div className="row mb-2">
          {category?.title && (
            <div className="col">
              <button
                onClick={() => {
                  dispatch("category", {});
                }}
                className="btn btn-outline-primary mb-2"
              >
                <span>{category?.title}</span>
                <AiOutlineClose />
              </button>
            </div>
          )}
          {getValue("search") && (
            <div className="col">
              <button
                onClick={() => {
                  changeObj("search", "");
                }}
                className="btn btn-outline-primary mb-2"
              >
                <span>{getValue("search")}</span>
                <AiOutlineClose />
              </button>
            </div>
          )}
        </div>
        <div className="row">
          {loading ? (
            <>
              <Loading count={3} />
            </>
          ) : (
            <>
              {data?.data?.length == 0 ? (
                <div className="empty-box-list">
                  <div
                    style={{ height: "400px" }}
                    className=" w-100 d-flex justify-content-center align-items-center"
                  >
                    <div>
                      <p>نتیجه‌ای با مشخصات مورد نظر شما پیدا نشد.</p>
                      <div className="d-flex justify-content-center mt-3">
                        <button
                          className="btn btn-outline-primary"
                          onClick={clearFilters}
                        >
                          حذف فیلتر ها
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                data?.data?.map((item, count) => {
                  return (
                    <Link key={count} className="col-12" to={item.slug}>
                      <div className="vertical-card">
                        <div className="image-card">
                          <img src={item?.main_image?.url} />
                        </div>
                        <div className="content-vertical-card">
                          <h6>{item.title}</h6>
                          <p className="city-province">{`${item?.province?.title}، ${item?.city?.title}`}</p>
                          <p className="price-card">
                            {renderPrice(item.price)}
                          </p>
                        </div>
                      </div>
                    </Link>
                  );
                })
              )}
            </>
          )}
        </div>
        {data.next_page_url &&
          <button
            className="btn btn-primary mb-4 mt-3 w-100"
            onClick={() => getNext(data.next_page_url)}>
            {nextLoading ? "در حال دریافت" : "نمایش بیشتر"}
          </button>
        }
      </div>
    </div>
  );
};

export default List;
